var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "send-inactive-a",
    d: "M20.9296324,9.83441009 L6.48268804,17.0578823 C6.35919342,17.1196296 6.20902516,17.0695735 6.14727785,16.9460789 C6.12058911,16.8927014 6.11387502,16.8315375 6.12834902,16.7736416 L7.6228255,10.7933308 L20.9769263,9.8036455 C20.9624579,9.81558239 20.9466085,9.82592204 20.9296324,9.83441009 Z M6.48268804,2.16372432 L20.6908255,9.26733081 L7.5908255,8.29733081 L6.12834902,2.44796502 C6.09486184,2.31401629 6.17630201,2.17828267 6.31025074,2.14479549 C6.36814672,2.13032149 6.42931058,2.13703559 6.48268804,2.16372432 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#26436F",
    fillRule: "evenodd",
    opacity: 0.504,
    transform: "rotate(-28 2.022 13.127)",
    xlinkHref: "#send-inactive-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendInactive);
export default __webpack_public_path__ + "static/media/send-inactive.8b8d43eeb253869f5057039bbbdb615b.svg";
export { ForwardRef as ReactComponent };